export default __webpack_public_path__ + "static/media/logo-ae-CHICLEFRIQUE.cfe77ba4.svg";